export default "__VITE_ASSET__CgN9dCl___"